'use strict';

var index = typeof Symbol === 'undefined' ? function (description) {
	return '@' + (description || '@') + Math.random();
} : Symbol;

module.exports = index;


//////////////////
// WEBPACK FOOTER
// ./node_modules/poor-mans-symbol/dist/poor-mans-symbol.common-js.js
// module id = ./node_modules/poor-mans-symbol/dist/poor-mans-symbol.common-js.js
// module chunks = 0